import React, { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '../../utils/config';
import '../../assets/css/Contact/Contact_Form.css';

function ContactForm() {
    const [step, setStep] = useState(1);
    const [antennas, setAntennas] = useState([]);
    const [selectedAntenna, setSelectedAntenna] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        antenne_id: '',
        raison: '',
        civilite: '',
        nom: '',
        prenom: '',
        telephone: '',
        email: '',
        sujet: '',
        message: '',
        rgpd_validation: false,
    });

    const contactReasons = [
        "Demande d'information",
        "Je souhaite demander un Dispositif de premier secours (DPS)",
        "Je souhaite me former",
        "Autre",
    ];

    const [message, setMessage] = useState(null);
    const formRef = useRef(null);

    useEffect(() => {
        fetch(`${API_BASE_URL}/antennes/?type=dps`)
            .then((response) => response.json())
            .then((data) => setAntennas(data))
            .catch((error) => console.error('Erreur lors de la récupération des antennes:', error));
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const updatedValue = type === 'checkbox' ? checked : value;

        setFormData((prevState) => ({
            ...prevState,
            [name]: updatedValue,
        }));
    };

    const handleSelectAntenna = (e) => {
        const antennaId = e.target.value;
        const antenna = antennas.find((a) => a.id === parseInt(antennaId, 10));
        setSelectedAntenna(antenna);
        setFormData({
            ...formData,
            antenne_id: antennaId,
            raison: '', // Réinitialisation du motif pour forcer la sélection
        });

        setStep(antennaId ? 2 : 1); // Afficher ou masquer la suite du formulaire
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        fetch(`${API_BASE_URL}/contact/submit`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setMessage({ type: 'error', text: data.error });
                } else {
                    setMessage({ type: 'success', text: data.message });
                }
            })
            .catch(() => setMessage({ type: 'error', text: 'Une erreur est survenue.' }))
            .finally(() => setIsSubmitting(false));
    };

    const resetForm = () => {
        setFormData({
            antenne_id: '',
            raison: '',
            civilite: '',
            nom: '',
            prenom: '',
            telephone: '',
            email: '',
            sujet: '',
            message: '',
            rgpd_validation: false,
        });
        setSelectedAntenna(null);
        setStep(1);
        setMessage(null);
    };

    return (
        <div ref={formRef} className="contact-form">
            <h2>Nous Contacter</h2>

            {message ? (
                <div className={message.type === 'success' ? 'success-message' : 'error-message'}>
                    <p>{message.text}</p>
                    {message.type === 'success' && (
                        <button onClick={resetForm} className="restart-button">
                            Recommencer
                        </button>
                    )}
                </div>
            ) : (
                <>
                    <div className="form-group">
                        <label>Antenne:</label>
                        <select
                            name="antenne_id"
                            value={formData.antenne_id}
                            onChange={handleSelectAntenna}
                            required
                        >
                            <option value="">Choisir une antenne</option>
                            {antennas.map((antenna) => (
                                <option key={antenna.id} value={antenna.id}>
                                    {antenna.nom}
                                </option>
                            ))}
                        </select>
                    </div>

                    {step >= 2 && (
                        <div className="form-group">
                            <label>Raison du contact:</label>
                            <select
                                name="raison"
                                value={formData.raison}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Choisir une raison</option>
                                {contactReasons.map((reason, index) => (
                                    <option key={index} value={reason}>
                                        {reason}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {formData.raison && (
                        <>
                            {formData.raison === "Je souhaite demander un Dispositif de premier secours (DPS)" ? (
                                <div className="form-group download-card">
                                    <p>
                                        Pour demander un Dispositif de premier secours (DPS), veuillez télécharger et
                                        retourner le formulaire ci-dessous rempli à l'adresse mail suivante :{" "}
                                        <strong>{selectedAntenna?.contact_dps || "Non disponible"}</strong>.
                                    </p>
                                    <div className="card">
                                        <a
                                            href="http://storage.l-co.fr/sfcb42-website/formulaires/DEMANDE_DE_DPS_A_REMPLIR.pdf"
                                            target="blank"
                                            download="Demande_DPS.pdf"
                                            className="card-download-link"
                                        >
                                            <span className="card-icon">📄</span>
                                            Télécharger le formulaire
                                        </a>
                                    </div>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label>Civilité:</label>
                                        <select
                                            name="civilite"
                                            value={formData.civilite}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Choisir</option>
                                            <option value="Monsieur">Monsieur</option>
                                            <option value="Madame">Madame</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Nom:</label>
                                        <input
                                            type="text"
                                            name="nom"
                                            value={formData.nom}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Prénom:</label>
                                        <input
                                            type="text"
                                            name="prenom"
                                            value={formData.prenom}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Téléphone:</label>
                                        <input
                                            type="text"
                                            name="telephone"
                                            value={formData.telephone}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Email:</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    {formData.raison === "Autre" && (
                                        <div className="form-group">
                                            <label>Objet:</label>
                                            <input
                                                type="text"
                                                name="sujet"
                                                value={formData.sujet}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    )}
                                    <div className="form-group">
                                        <label>Message:</label>
                                        <textarea
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="checkbox-group">
                                        <input
                                            type="checkbox"
                                            name="rgpd_validation"
                                            checked={formData.rgpd_validation}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label>
                                            J'accepte que les informations saisies soient stockées pour permettre de me
                                            recontacter dans le cadre de ma demande.
                                        </label>
                                    </div>
                                    <div className="contact-form-buttons">
                                        <button type="submit" disabled={isSubmitting}>
                                            {isSubmitting ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                </>
                                            ) : (
                                                "Envoyer"
                                            )}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
}

export default ContactForm;
